import {
  Box,
  DialogActions,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import SubscriptionTeasing from '../subscription/SubscriptionTeasing';
import Button, { WhiteButton } from '../ui/Button';
import LoadingButton from '../ui/LoadingButton';

interface CompleteQuestionProps {
  isComplete: string;
  setIsComplete: (value: string) => void;
  loading: boolean;
  onClose: () => void;
  onNext: (payload?: any) => void;
  onNextLabel: string;
  subscribed: boolean;
}

const CompleteQuestion = ({
  isComplete,
  setIsComplete,
  onClose,
  onNext,
  loading,
  onNextLabel,
  subscribed,
}: CompleteQuestionProps) => {
  const { t } = useTranslation('cnc-reports');

  useEffect(() => {
    if (!subscribed && isComplete !== 'complete') {
      setIsComplete('complete');
    }
  }, [subscribed, isComplete, setIsComplete]);

  return (
    <>
      <RadioGroup
        value={isComplete}
        onChange={(e) => setIsComplete(e.target.value)}
      >
        <FormControlLabel
          value="complete"
          control={<Radio />}
          label={t('cnc-reports:local-type.complete')}
        />
        <FormControlLabel
          value="not-complete"
          control={<Radio />}
          label={
            <Box display="flex" alignItems="center" gap={1}>
              {t('cnc-reports:local-type.not-complete')}
              {!subscribed && (
                <SubscriptionTeasing
                  teasingButton={t(
                    'common:subscription.proratizeProject.teasingButton',
                  )}
                  text={t('common:subscription.proratizeProject.modalText')}
                  title={t('common:subscription.proratizeProject.modalTitle')}
                  link={t('common:subscription.proratizeProject.knowMoreLink')}
                />
              )}
            </Box>
          }
          disabled={!subscribed}
        />
      </RadioGroup>
      <DialogActions>
        <WhiteButton onClick={onClose}>{t('common:cancel')}</WhiteButton>
        <LoadingButton
          onClick={onNext}
          color="primary"
          disabled={!isComplete}
          loading={loading}
        >
          {onNextLabel}
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default CompleteQuestion;
